import AgentsScreen from "@/components/agents/AgentsPage";

export default function AgentsPage() {
  return <AgentsScreen />;
}
